import { Box, Flex, Text } from "@chakra-ui/react";
import React from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";

/**
 * Tab bar for agentic wizard mode, rendered above the stepper row.
 *
 * Figma node 20141-135815: "Candidates | Guide | Options | Invites | Test Interviews"
 * In agentic wizard mode, the Candidates tab is visible but disabled.
 */

interface TabDef {
  label: string;
  pathSegment: string;
  disabled?: boolean;
}

const AGENTIC_TABS: TabDef[] = [
  { label: "Candidates", pathSegment: "candidates", disabled: true },
  { label: "Guide", pathSegment: "guide" },
  { label: "Options", pathSegment: "settings" },
  { label: "Notifications", pathSegment: "notifications" },
  { label: "Test interviews", pathSegment: "test-interview" },
];

const AgenticWizardTabBar: React.FC = () => {
  const { aiInterviewerId } = useParams<{ aiInterviewerId: string }>();
  const location = useLocation();
  const navigate = useNavigate();

  const activeSegment = AGENTIC_TABS.find(
    (tab) => !tab.disabled && location.pathname.includes(`/${tab.pathSegment}`)
  )?.pathSegment;

  return (
    <Flex
      borderBottom="1px solid"
      borderColor="gray.200"
      gap="0"
      role="tablist"
    >
      {AGENTIC_TABS.map((tab) => {
        const isActive = activeSegment === tab.pathSegment;
        const isDisabled = tab.disabled === true;
        return (
          <Box
            key={tab.pathSegment}
            as="button"
            type="button"
            role="tab"
            aria-selected={isActive}
            aria-disabled={isDisabled || undefined}
            pb="2.5"
            pt="3"
            px="4"
            mb="0"
            cursor={isDisabled ? "not-allowed" : "pointer"}
            fontWeight={isActive ? "semibold" : "normal"}
            fontSize="sm"
            color={isDisabled ? "gray.400" : isActive ? "blue.600" : "gray.600"}
            borderBottom="2px solid"
            borderColor={isActive ? "blue.600" : "transparent"}
            _hover={isDisabled ? undefined : { color: "blue.600" }}
            onClick={() => {
              if (isDisabled || !aiInterviewerId) return;
              navigate(
                {
                  pathname: `/ai-interviewer/${aiInterviewerId}/${tab.pathSegment}`,
                  search: location.search,
                },
                { replace: true }
              );
            }}
          >
            <Text whiteSpace="nowrap">{tab.label}</Text>
          </Box>
        );
      })}
    </Flex>
  );
};

export { AgenticWizardTabBar };
